import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import DateTime from '_class/DateTime';
import SectionTitle from 'components/Presentation/SectionTitle';
import Modal from 'containers/Modals/Modal';
import NoteForm from 'containers/Forms/Note';
import { getMentorNotesByReference, resetActiveNote, setActiveNote, removeNote } from 'actions/notes';
import swal from 'sweetalert2';
import { Icon, Button, Checkbox, Block } from '@haldor/ui';

var MentorNotes = /*#__PURE__*/function (_Component) {
  _inherits(MentorNotes, _Component);

  var _super = _createSuper(MentorNotes);

  function MentorNotes(props) {
    var _this;

    _classCallCheck(this, MentorNotes);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState({
        loading: true
      });

      _this.props.getMentorNotesByReference(_this.props.user, 'STUDENT').then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleNoteForm", function () {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var values = arguments.length > 1 ? arguments[1] : undefined;
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var user;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (reload) {
                    user = _this.props.user;

                    if (_this.props.isUpdating != null) {
                      _this.props.isUpdating();
                    }

                    _this.props.getMentorNotesByReference(user, "STUDENT").then(function () {
                      if (_this.props.isUpdated != null) {
                        _this.props.isUpdated();
                      }
                    });

                    if (_this.props.isUpdating == null) {
                      _this.setState({
                        noteForm: !_this.state.noteForm
                      });

                      _this.props.resetActiveNote();

                      resolve(1);
                    }
                  } else {
                    _this.setState({
                      noteForm: !_this.state.noteForm
                    });

                    _this.props.resetActiveNote();

                    resolve(1);
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "renderNote", function (reference) {
      var date = new DateTime(reference.created);

      if (!reference["public"] && !_this.state.showPrivateNotes) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "note",
        key: reference.id
      }, /*#__PURE__*/React.createElement("h3", null, reference.title), /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: reference.text
        }
      }), /*#__PURE__*/React.createElement("p", {
        className: "creator"
      }, reference.author != null ? reference.author.firstName + " " + reference.author.lastName : null, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, " ", date.getFromNow()), /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, ' • ', " ", reference["public"] ? _this.props.translate('shared-note') : _this.props.translate('private-note')), reference.creator == _this.props.currentUser.id || reference.id == _this.props.createdNote ? /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400,
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onNoteClick(reference);
        }
      }, ' • ', " ", /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", _this.props.translate('Edit')) : null, reference.creator == _this.props.currentUser.id || reference.id == _this.props.createdNote ? /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400,
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onNoteRemove(reference);
        }
      }, ' • ', " ", /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", _this.props.translate('Remove')) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "onNoteClick", function (note) {
      _this.props.setActiveNote(note);

      _this.setState({
        noteForm: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNoteRemove", function (note) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('note-delete-prompt'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.removeNote(note.id);
        }
      });
    });

    _this.state = {
      loading: false,
      noteForm: false,
      showPrivateNotes: false
    };
    return _this;
  }
  /* Lifecycle methods */


  _createClass(MentorNotes, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading) return /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });
      var notes = [];

      if (this.props.notes != null) {
        notes = this.props.notes;
        notes.sort(function (a, b) {
          return new Date(b.created) - new Date(a.created);
        });
      }

      var isStudent = this.props.isStudent;
      return /*#__PURE__*/React.createElement("div", {
        className: "meeting single-instance"
      }, !isStudent ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.noteForm,
        type: "small",
        onClose: function onClose() {
          return _this2.toggleNoteForm();
        },
        title: this.props.translate('note')
      }, /*#__PURE__*/React.createElement(NoteForm, {
        onAbort: this.toggleNoteForm,
        reference: "STUDENT",
        id: this.props.user
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "section single-section notes",
        style: {
          border: 0,
          margin: 0,
          padding: 0
        }
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, this.props.translate('notes'))), /*#__PURE__*/React.createElement(Block, null, !isStudent ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.showPrivateNotes,
        label: this.props.translate('show-private-notes'),
        onChange: function onChange(value) {
          return _this2.setState({
            showPrivateNotes: value
          });
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      })) : null, notes.map(function (note) {
        return _this2.renderNote(note);
      }), notes.length == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center"
      }, this.props.translate('no-notes')) : null, !isStudent ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.toggleNoteForm();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), this.props.translate('write')) : null)));
    }
  }]);

  return MentorNotes;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    notes: state.Notes.mentorNotes,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getMentorNotesByReference: getMentorNotesByReference,
  resetActiveNote: resetActiveNote,
  setActiveNote: setActiveNote,
  removeNote: removeNote
})(MentorNotes);